export const documentSideConfigurationConstants = {
    FRONT : 1,
    FRONT_MANDATORY_BACK_OPTIONAL : 2,
    FRONT_MANDATORY_BACK_MANDATORY : 3
  };

  export const noDocReplacements = {
    Aadhaar: {
      uiLabel: "Digilocker",
      storedValue: "Digilocker",
    },
    "Aadhaar 2.0": {
      uiLabel: "Digilocker",
      storedValue: "Digilocker 2.0",
    },
    PAN: {
      uiLabel: "PAN Verification",
      storedValue: "PAN Verification",
    },
    "Driving License": {
      uiLabel: "Driving License Verification",
      storedValue: "Driving License Verification",
    },
};

export const secondDocReplacements = {
  Aadhaar: ["Digilocker", "Digilocker 2.0"],
  Digilocker: ["Aadhaar", "Digilocker 2.0"],
  "Digilocker 2.0": ["Aadhaar", "Digilocker"],
  PAN: ["PAN Verification"],
  "PAN Verification": ["PAN"],
  "Driving License": ["Driving License Verification"],
  "Driving License Verification": ["Driving License"],
  "Passport": ["International Passport"],
  "International Passport": ["Passport"]
};

